import { logger } from '../../utilities/logger';
import { useEffect } from 'react';
import { millisecondsToSeconds } from 'date-fns';
import { tokenDispatcher } from '../../inter_op/native_dispatchers/token_dispatcher/token_dispatcher';
import { TokenDispatcherAction } from '../../inter_op/native_dispatchers/token_dispatcher/token_dispatcher.constants';
import { useAppState } from '../../contexts/app_state/use_app_state_context';
import { AppState } from '../../contexts/app_state/app_state_context';
import { useTokenContext } from '../../contexts/token/use_token_context';

const requestToken = () => {
  logger.debug({
    message: 'requestToken',
  });
  tokenDispatcher.postMessage({
    action: TokenDispatcherAction.requestToken,
  });
};

// 2 minutes
export const MIN_TIME_TO_REQUEST_IN_MILLISECONDS = 120000;
const INVALID_TIMER_ID = 0;

const scheduleTokenRenewal = (tokenExpire: Date) => {
  const timeUntilExpiry = tokenExpire.getTime() - Date.now();
  const timeUntilRequest = Math.max(MIN_TIME_TO_REQUEST_IN_MILLISECONDS, timeUntilExpiry);

  if (timeUntilRequest === MIN_TIME_TO_REQUEST_IN_MILLISECONDS) {
    requestToken();
    return INVALID_TIMER_ID;
  }

  logger.info({
    message: `Token renewal scheduled in ${millisecondsToSeconds(timeUntilRequest)}s`,
  });
  return window.setTimeout(requestToken, timeUntilRequest);
};

export const useRequestToken = (): void => {
  const { status } = useAppState();
  const { expiry: tokenExpire } = useTokenContext();

  useEffect(() => {
    let timerId = INVALID_TIMER_ID;

    if (tokenExpire && status === AppState.active) {
      timerId = scheduleTokenRenewal(tokenExpire);
    }

    return () => {
      clearTimeout(timerId);
    };
  }, [status, tokenExpire]);
};
